/**
* Determination触发时机
 */

/**
* Determination触发时机
*/
export enum CommonTriggerPointType {
    /**
     * 不执行,用于判断时机比较结果
     */
    None = 0,

    /**
     * 数据更新后
     * 可以操作持久化或非持久化属性和Node
     */
     AfterModify = 1,

    
    /**
     一致性检查前，保存中进行Validation之前进行，是修改数据的最后时机
     */
     BeforeSave = 2,
}


export const BETriggerTimePointTypes: Array<{ index: number, value: CommonTriggerPointType }> = [
    { index: 0, value: CommonTriggerPointType.None },
    { index: 1, value: CommonTriggerPointType.AfterModify },
    { index: 2, value: CommonTriggerPointType.BeforeSave },
];
